<template>
  <div>
    <b-row>
      <b-col cols="5">
        <b-form-group label="Versión de la app">
          <b-form-input v-model="localAppVersion" />
          <small class="text-muted">Si introduces 0, no se hará la comprobación de versión en la app.</small>
        </b-form-group>
        <b-button variant="primary" @click="updateVersion">
          Actualizar versión
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {BCol, BRow, BButton, BFormGroup, BFormInput} from "bootstrap-vue";

export default {
  components: {BCol, BRow, BButton, BFormGroup, BFormInput},
  data() {
    return {
      localAppVersion: ''
    }
  },
  computed: {
    ...mapGetters({
      appVersion: 'appVersion/getVersion'
    }),
  },
  watch: {
    appVersion(val) {
      this.localAppVersion = val
    }
  },
  created() {
    this.getVersion()
  },
  methods: {
    ...mapActions({
      edit: 'appVersion/updateVersion',
      getVersion: 'appVersion/fetchVersion',
    }),
    async cargarVersion() {
      this.error = false
      try {
        await this.getVersion()
        this.localAppVersion = this.appVersion
      } catch {
        this.error = true
      }
    },
    async updateVersion() {
      await this.edit(this.localAppVersion)
    }
  }
}
</script>
